const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';

export const getImageUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${SERVER_URL}${path}`;  
};


export const fetchGems = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const res = await fetch(`${BASE_URL}/gems${query ? '?' + query : ''}`);
  const data = await res.json();
  // Support both { gems: [] } and plain array responses
  return Array.isArray(data) ? data : (data.gems || []);
};

export const fetchGem = (id) =>
  fetch(`${BASE_URL}/gems/${id}`).then(r => r.json());

export const fetchGemsByType = (gemType) =>
  fetch(`${BASE_URL}/gems/type/${encodeURIComponent(gemType)}`).then(r => r.json());

export const fetchStats = (token) =>
  fetch(`${BASE_URL}/gems/admin/stats`, {
    headers: { Authorization: `Bearer ${token}` }
  }).then(r => r.json());

export const createGem = (formData, token) =>
  fetch(`${BASE_URL}/gems`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData
  }).then(r => r.json());

export const updateGem = (id, formData, token) =>
  fetch(`${BASE_URL}/gems/${id}`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}` },
    body: formData
  }).then(r => r.json());

export const deleteGem = (id, token) =>
  fetch(`${BASE_URL}/gems/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` }
  }).then(r => r.json());

